/* eslint-disable consistent-return */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import {
  PhoneInput, Form, Button,
} from 'components/common';
import { verifyPhone } from 'models/user';
import { StatusContext } from 'contexts/statusContext';

const PhoneEnterence = ({
  t, userState, updateUserState, router,
}) => {
  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await verifyPhone({
          userId: userState.id,
          phoneNumber: userState.phoneCode + userState.phone,
        });
        router.push({
          pathname: '/register/code-enterence',
          query: {
            code: userState.phoneCode,
            phone: userState.phone,
            id: userState.id,
          },
        });
      } catch (error) {
        console.log('verifyPhoneErr', error);
        setErrorState({
          title: t('alert'),
          text: error.message,
          buttonText: t('close'),
          onClickButton: () => setErrorState({}),
        });
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-lg-0">
      <Form layout="vertical" onFinish={onFormSubmit}>
        <div className="fs-22 mb-2">{t('stepNumber', { step: 4 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('verifyYourPhoneNumber')}</div>
        <div className="mb-5">Aktivasyonunuzu gerçekleştirmek için telefon numaranızı girin.</div>

        <div className="row">
          <div className="col">
            <PhoneInput
              name="phone"
              label={t('phoneNumber')}
              value={userState.phone}
              onChange={updateUserState}
              containerStyle={{ width: '80%' }}
              required
              mobileNumber
            />
          </div>
        </div>

        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('next')}
        />
      </Form>
    </div>
  );
};

PhoneEnterence.propTypes = {
  t: PropTypes.func,
  updateUserState: PropTypes.func,
  userState: PropTypes.object,
  router: PropTypes.object,
};

export default withTranslation('common')(PhoneEnterence);
